import { DAY_KEYS, type DayKey } from "@/lib/days";
import type { CounterConfig, CounterDayData } from "@/lib/schema";

export function scoreDay(config: CounterConfig, dayData: unknown): number {
  const data = (dayData ?? { count: 0 }) as CounterDayData;
  return Math.min(data.count * config.points, config.maxPoints);
}

// Where the count stops, because the Daily maximum is the day's finish line
// (docs/adr/0017). Ceil and never floor: at 3p per unit capped at 10p, floor
// stops at three units for 9p, so the cap is never reached and the day could
// never read Ferdiglogget. The last step may therefore be worth less than a
// full unit — accepted, and stated in the glossary.
export function unitCeiling(config: CounterConfig): number {
  return Math.ceil(config.maxPoints / config.points);
}

export function scoreWeek(
  config: CounterConfig,
  runtime: { week: unknown; days: Record<DayKey, unknown> },
): number {
  let total = 0;
  for (const k of DAY_KEYS) total += scoreDay(config, runtime.days[k]);
  return total;
}

export function maxScoreWeek(config: CounterConfig): number {
  return 7 * config.maxPoints;
}
